/**
 * Client API pour l'onboarding (choix d'espace de jeu + intention d'abonnement).
 */

import { BACKEND_URL } from '../config';

export type SubscribeIntent = 'none' | 'subscribed' | 'trial' | 'postponed';

export interface OnboardingChoices {
  wants_detente: boolean;
  wants_competition: boolean;
  subscribe_intent?: SubscribeIntent;
}

function authHeaders(token?: string): HeadersInit {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function saveOnboardingChoices(
  token: string,
  choices: OnboardingChoices,
): Promise<void> {
  const res = await fetch(`${BACKEND_URL}/api/onboarding/choices`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders(token) },
    body: JSON.stringify(choices),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || data.message || `save_failed_${res.status}`);
  }
}

export async function updateSubscribeIntent(
  token: string,
  intent: SubscribeIntent,
): Promise<void> {
  const res = await fetch(`${BACKEND_URL}/api/onboarding/intent`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders(token) },
    body: JSON.stringify({ subscribe_intent: intent }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || data.message || `save_failed_${res.status}`);
  }
}
